module.exports = __webpack_public_path__ + "static/img/jianting2.42c2b88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/jianting2.png
// module id = MMEl
// module chunks = 24